import { SmeList } from './SmePages';

export default SmeList;
